module.exports = __webpack_public_path__ + "img/indoor_b.58a97546.svg";